const actions = {

    FETCH_ALL_STUDENT_EMAILS: 'FETCH_ALL_STUDENT_EMAILS',
    fetchAllStudentEmailsAction: (data) => ({
        type: actions.FETCH_ALL_STUDENT_EMAILS,
        data
    }),

    FETCH_ALL_STUDENT_INFO: 'FETCH_ALL_STUDENT_INFO',
    fetchAllStudentInfoAction: (data) => ({
        type: actions.FETCH_ALL_STUDENT_INFO,
        data
    }),


    // ============================
    // Teacher Emails
    // ============================

    FETCH_ALL_TEACHER_EMAILS: 'FETCH_ALL_TEACHER_EMAILS',
    fetchAllTeacherEmailsAction: (data) => ({
        type: actions.FETCH_ALL_TEACHER_EMAILS,
        data
    }),

    FETCH_ALL_TEACHER_INFO: 'FETCH_ALL_TEACHER_INFO',
    fetchAllTeacherInfoAction: (data) => ({
        type: actions.FETCH_ALL_TEACHER_INFO,
        data
    }),

    FETCH_TEACHER_EMAILS: 'FETCH_TEACHER_EMAILS',

    fetchTeacherEmailsAction: (data) => ({
        type: actions.FETCH_TEACHER_EMAILS,
        data
    }),

    FETCH_TEACHER_SENT_EMAILS: 'FETCH_TEACHER_SENT_EMAILS',

    fetchTeacherSentEmailsAction: (data) => ({
        type: actions.FETCH_TEACHER_SENT_EMAILS,
        data
    }),

    FETCH_TEACHER_UNIFIED_EMAILS: 'FETCH_TEACHER_UNIFIED_EMAILS',

    fetchTeacherUnifiedEmailsAction: (data) => ({
        type: actions.FETCH_TEACHER_UNIFIED_EMAILS,
        data
    }),

    // ============================
    // Student Emails
    // ============================
    FETCH_STUDENT_EMAILS: 'FETCH_STUDENT_EMAILS',

    fetchStudentEmailsAction: (data) => ({
        type: actions.FETCH_STUDENT_EMAILS,
        data
    }),

    FETCH_CLASS_TEACHER_ZOOM_EMAILS: 'FETCH_CLASS_TEACHER_ZOOM_EMAILS',

    fetchClassTeacherZoomEmailsAction: (data) => ({
        type: actions.FETCH_CLASS_TEACHER_ZOOM_EMAILS,
        data
    }),

    // ============================
    // Official Emails
    // ============================

    FETCH_ALL_OFFICIAL_EMAILS: 'FETCH_ALL_OFFICIAL_EMAILS',
    fetchAllOfficialEmailsAction: (data) => ({
        type: actions.FETCH_ALL_OFFICIAL_EMAILS,
        data
    }),
};

export default actions;
